var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMp3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_42661_1908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72917 2.0835C4.80869 2.0835 4.0625 2.82969 4.0625 3.75016V21.2502C4.0625 22.1706 4.80869 22.9168 5.72917 22.9168H19.2708C20.1913 22.9168 20.9375 22.1706 20.9375 21.2502V7.29183L15.7292 2.0835H5.72917Z",
    fill: "#F16C00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 12.4795C16.8597 12.6333 16.7989 12.7794 16.7115 12.9096C16.6404 13.0177 16.5683 13.0901 16.496 13.0534C16.425 13.0534 16.3882 12.5866 16.3537 12.5142C16.2986 12.3887 16.2624 12.2557 16.246 12.1196C16.2104 11.8324 16.1027 11.5795 15.9226 11.4725C15.7437 11.3289 15.4937 11.2208 15.1704 11.1483C14.8194 11.0801 14.4884 10.9331 14.2024 10.7183C13.9158 10.5022 13.5936 10.3229 13.4147 10.1068C13.2346 9.92746 13.0912 9.89061 13.0201 9.92746C12.9123 9.96313 12.8768 10.0712 12.8768 10.1792V16.8621C12.8768 17.0426 12.8412 17.2575 12.769 17.4737C12.6979 17.6898 12.6611 17.9047 12.4822 18.1198C12.3033 18.3359 12.0523 18.4795 11.73 18.6233C11.4066 18.767 11.0132 18.8394 10.5821 18.875C10.1376 18.903 9.69337 18.8164 9.29201 18.6233C8.94666 18.4646 8.64076 18.2314 8.39631 17.9403C8.18081 17.653 8.073 17.3656 8.073 17.0057C8.073 16.6828 8.21753 16.3596 8.53966 16.0721C8.82638 15.7847 9.14865 15.5687 9.5075 15.4607C9.86545 15.3526 10.1888 15.2814 10.511 15.2814C10.8343 15.2814 11.3355 15.2814 11.5865 15.3536C11.8367 15.425 12.0167 15.4617 12.16 15.4974V9.1367C12.16 8.92056 12.2312 8.74217 12.339 8.59855C12.4467 8.4548 12.6256 8.38241 12.8045 8.34686C12.9846 8.31118 13.1279 8.34686 13.2356 8.45493C13.3434 8.52616 13.2356 8.67095 13.3779 8.81353C13.4858 8.95728 13.6291 9.13774 13.8091 9.35272C13.988 9.56886 14.2024 9.74816 14.4891 9.92759C14.7403 10.1069 14.9558 10.215 15.1347 10.323C15.3138 10.3944 15.4937 10.4668 15.6371 10.5392C15.7803 10.6104 15.9593 10.6818 16.1027 10.7898C16.2459 10.8979 16.426 11.0415 16.6039 11.2577C16.7838 11.4738 16.8906 11.6521 16.9272 11.8681C16.9272 12.0842 16.9272 12.2992 16.8906 12.4786V12.4797V12.4795Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4489 6.80322H16.2175L20.9376 11.5233V7.2915L20.4489 6.80322Z",
    fill: "url(#paint0_linear_42661_1908)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 7.2915L15.7292 2.08317C15.7292 4.95965 18.061 7.2915 20.9375 7.2915Z",
    fill: "#F9C499"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_42661_1908",
    x: 4.0625,
    y: 1.0835,
    width: 16.875,
    height: 22.8335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42661_1908"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_42661_1908",
    result: "effect2_innerShadow_42661_1908"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42661_1908",
    x1: 17.2755,
    y1: 5.74528,
    x2: 21.9955,
    y2: 10.4653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.9091f62700687d8af3c5bcfc608ef21d.svg";
export { ForwardRef as ReactComponent };